export default "__VITE_ASSET__364f2f04__"